import React from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';

import FavoriteDesign from '../../components/Product/FavoriteDesign/FavoriteDesign';
import {NEGATIVE_FAVORITE_COUNT, POSITIVE_FAVORITE_COUNT} from '../../constants/Design';
import {isRegisteredUser, RegisteredUser, UserState} from '../../shapes/user';
import {State} from '../../store/initialState';
import {fetchFavoriteState} from '../../utils/fetch';
import {getFavoriteCount} from '../../utils/stateToPropsHelpers';
import {isUndefined} from '../../utils/validation';


export interface FavoriteDesignContainerProps {
  designId: number;
  parentName?: string;
}

const FavoriteDesignContainer = ({designId, parentName}: FavoriteDesignContainerProps): JSX.Element => {
  const {isFavorite, favoriteCount} = useSelector((state: State) => {
    const resgisteredUser = isRegisteredUser(state.user as UserState) && state.user as RegisteredUser;
    const favoriteDesignIds = resgisteredUser && resgisteredUser.favorites ? resgisteredUser.favorites.design_ids : [];

    return {
      isFavorite: !isUndefined(favoriteDesignIds) && favoriteDesignIds.includes(designId),
      favoriteCount: getFavoriteCount(state, designId)
    };
  }, shallowEqual);
  const dispatch = useDispatch();
  const dispatchFavoriteState = (designId: number, addedFavoriteCount: number) => {
    fetchFavoriteState(dispatch, designId, addedFavoriteCount);
  };

  function favoriteDesign() {
    const addedFavoriteCount = isFavorite === false ? POSITIVE_FAVORITE_COUNT : NEGATIVE_FAVORITE_COUNT;

    dispatchFavoriteState(designId, addedFavoriteCount);
  }

  return (
    <FavoriteDesign
      isFavorite={isFavorite}
      favoriteCount={favoriteCount}
      favoriteDesign={favoriteDesign}
      parentName={parentName}/>
  );
};

export default FavoriteDesignContainer;
